import { createContext, useState } from "react";

const CvvContext = createContext(["", () => {}]);

export const CvvProvider = ({ children }) => {
  const [cvv, setCvv] = useState("");

  return <CvvContext.Provider value={[cvv, setCvv]}>{children}</CvvContext.Provider>;
};

export default CvvContext;
